import moment from "moment";

export const FIXED_SELECT_FIELD_SX = {
  width: "100%",
  "& .MuiInputBase-root": {
    width: "100%",
  },
  "& .MuiSelect-select": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

export const TABLE_SCROLL_CONTAINER_SX = {
  maxHeight: 560,
  overflow: "auto",
  border: "1px solid #ddd",
  borderRadius: 2,
};

const hasTextValue = (value) => {
  if (typeof value !== "string") return false;
  return value.trim() !== "";
};

export const hasValue = (value) => {
  if (value === null || value === undefined) return false;

  if (Array.isArray(value)) {
    return value.some((item) => hasValue(item));
  }

  if (typeof value === "string") {
    return hasTextValue(value);
  }

  return true;
};

export const isValidIsoDate = (value) => {
  if (!hasValue(value)) return true;
  return moment(value, "YYYY-MM-DD", true).isValid();
};

export const hasInvalidDateValue = (value) => hasValue(value) && !isValidIsoDate(value);

export const isRowComplete = (row, requiredFields = [], columnsConfig = []) =>
  requiredFields.some((field) => {
    const value = row?.[field];
    const columnConfig = columnsConfig.find((col) => col.field === field);

    // Check if field has conditional requirement
    if (columnConfig?.conditionalRequired) {
      const isConditionallyRequired = columnConfig.conditionalRequired(row);
      if (!isConditionallyRequired) {
        // Field is not required based on condition, so it's complete
        return true;
      }
    }

    if (!hasValue(value)) return false;

    if (field.toLowerCase().includes("date")) {
      return isValidIsoDate(value);
    }

    return true;
  });

export const KOT_SELECT_MENU_PROPS = {
  MenuProps: {
    PaperProps: {
      style: {
        maxHeight: 250,
      },
    },
  },
};
